/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  var startX = 0;
  var startY = 0;

  function isProductGalleryTouch(event) {
    return event.target.closest && event.target.closest('.template-product .product-gallery__carousel');
  }

  document.addEventListener('touchstart', function(event) {
    if (!isProductGalleryTouch(event) || !event.touches || event.touches.length !== 1) {
      return;
    }

    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function(event) {
    if (!isProductGalleryTouch(event) || !event.touches || event.touches.length !== 1) {
      return;
    }

    var deltaX = Math.abs(event.touches[0].clientX - startX);
    var deltaY = Math.abs(event.touches[0].clientY - startY);

    if (deltaY > 8 && deltaY > deltaX) {
      event.stopImmediatePropagation();
    }
  }, { passive: true, capture: true });
})();

// Sync the product gallery to the pre-selected variant on page load.
// When the first variant is sold out, Shopify pre-selects the first available
// variant server-side but the gallery's data-initial-media-id still points to
// the first variant's image. Firing variant:change after section init corrects this.
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      var sectionEl = document.querySelector('section[data-section-type="product"]');
      if (!sectionEl) return;

      var variantScript = sectionEl.querySelector('script[data-variant]');
      if (!variantScript) return;

      var variant;
      try { variant = JSON.parse(variantScript.textContent); } catch (e) { return; }
      if (!variant || !variant.featured_media) return;

      var galleryEl = sectionEl.querySelector('.product-gallery__carousel');
      if (!galleryEl) return;

      // Only fire if the gallery is currently showing a different image
      var initialMediaId = galleryEl.getAttribute('data-initial-media-id');
      if (String(variant.featured_media.id) === initialMediaId) return;

      sectionEl.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }, 0);
  });
})();
